import React from "react";
import "./about.css";

import about1 from "../../assets/1843.png";
import about2 from "../../assets/2903.png";
import about7 from "../../assets/2331.png";
import about3 from "../../assets/1170.png";
import about4 from "../../assets/1573.png";
import about6 from "../../assets/2640.png";

// import {BsArrowRight} from 'react-icons/bs'

function About() {
  return (
    <section id="about" className="container about_container">
      <div className="image_slides">
        <img
          src={about1}
          className="big_img"
          style={{
            width: "350px",
            borderRadius: "40px",
          }}
        />
        <img src={about3} className="p-10" />
        <img src={about7} className="p-10" />
        <img src={about2} className="p-10" />
        <img src={about4} className="p-10" />
        <img src={about6} className="p-10" />
      </div>
      <div className=" about_text">
        <div className="about_text_header">
          <h5>About Us</h5>
          <h2>What is MonkeyDoo 🐵 ?</h2>
        </div>
        <div className="about_text_main">
          <h5>
            MonkeyDoos are a collection of 3,000 NFTs (non-fungible tokens) that
            are made of a large number of high quality visual traits. Each
            MonkeyDoo is unique in its own way, but not equally rare. The
            MonkeyDoo collection includes dozens of rare layers that make some
            NFTs more valuable than the others.
            <br />
            <br />{" "}
            <p>
              Owning a MonkeyDoo allows you to be part of the upcoming and
              original community on the ETC blockchain. The minting is
              completely random and allows every minter a fair chance of owning
              the top rare MonkeyDoos for just one $ETC.
            </p>
          </h5>
        </div>
        <a
          href="/#minter"
          className="btn btn-primary"
          style={{
            height: "initial",
          }}
        >
          Mint Now !
        </a>
      </div>
    </section>
  );
}

export default About;
